export default __webpack_public_path__ + "08fd8ece70709ad948235380740d6f58.png";